import React, { useContext } from 'react';
import { Grid } from '@mui/material';
import { ChartingCodeContext } from 'pages/Test/lib/chartingCodeContext';
import BasicInput from 'pages/Test/CodeRenderers/BasicInput';
import SelectInput from 'pages/Test/CodeRenderers/SelectInput';
import CheckboxInput from 'pages/Test/CodeRenderers/CheckboxInput';
import TextareaInput from 'pages/Test/CodeRenderers/TextareaInput';



export const CodeLayout = () => {
	const { layout, values } = useContext(ChartingCodeContext);

	if(!layout) {
		return null;
	}

	return (
		<Grid container spacing={2}>
			{layout.map((fieldConfig, index) => {
				switch(fieldConfig.inputType) {
					case 'integer':
					case 'decimal':
					case 'date':
					case 'text':
						return <BasicInput
							key={index}
							fieldConfig={fieldConfig}
							value={values[ fieldConfig.valueName ] ?? ''}
						/>;

					case 'checkbox':
						return <CheckboxInput
							key={index}
							fieldConfig={fieldConfig}
							value={values[ fieldConfig.valueName ] || false}
						/>;

					case 'textarea':
						return <TextareaInput
							key={index}
							fieldConfig={fieldConfig}
							value={values[ fieldConfig.valueName ] ?? ''}
						/>;

					case 'select':
						return <SelectInput
							key={index}
							fieldConfig={fieldConfig}
							value={values[ fieldConfig.valueName ] ?? ''}
						/>;

					default:
						return <div key={index}>{fieldConfig.inputType} is not yet implemented</div>;
				}
			})}
		</Grid>
	);
};

export default CodeLayout;
